<template>
  <section>
    <b-card>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <h5 class="mb-0">
          Kategoriler
        </h5>
        <b-input-group
          size="sm"
          class="ml-1"
          style="width: 520px;"
        >
          <b-form-input
            v-model="searchCategory"
          />
          <b-input-group-append>
            <b-button
              size="sm"
              variant="primary"
              @click="addAllFilteredCategories"
            >
              Tümünü ekle
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              @click="removeAllFilteredCategories"
            >
              Tümünü kaldır
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <b-badge
        v-for="category in categories"
        :key="category.key || category.id || category.value || category.name"
        :variant="selectedCategoriesFromStore.includes(category) ? 'primary' : 'secondary'"
        class="mr-1 mb-1"
        @click="addRemoveCategory(category)"
      >
        {{ category.value || category.name || category.label }}
      </b-badge>
    </b-card>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Categories',
  data() {
    return {
      searchCategory: '',
    }
  },
  computed: {
    ...mapGetters('tySearchProduct', {
      categoriesFromStore: '_categories',
      selectedCategoriesFromStore: '_selectedCategories',
    }),
    categories() {
      if (this.searchCategory) {
        const searchValue = this.searchCategory.toLowerCase()
        return this.categoriesFromStore.filter(category => {
          const label = (category.value || category.name || category.label || '').toLowerCase()
          return label.includes(searchValue)
        })
      }
      return this.categoriesFromStore
    },
  },
  methods: {
    addRemoveCategory(category) {
      if (this.selectedCategoriesFromStore.includes(category)) {
        this.$store.commit('tySearchProduct/removeSelectedCategory', category)
      } else {
        this.$store.commit('tySearchProduct/addSelectedCategory', category)
      }
    },
    addAllFilteredCategories() {
      this.categories.forEach(category => {
        this.$store.commit('tySearchProduct/addSelectedCategory', category)
      })
    },
    removeAllFilteredCategories() {
      this.categories.forEach(category => {
        this.$store.commit('tySearchProduct/removeSelectedCategory', category)
      })
    },
  },
}

</script>
